

import React from 'react';
import {useTranslation} from "react-i18next";
import Helmet from "react-helmet";
import Zoom from "react-medium-image-zoom";
import {Link} from "react-router-dom";
import INFO from '../core/data/basic';
import ScienceWorkApi from "../components/api/s_work_api";
import CertificatesApi from "../components/api/certificate_api";
import {MotionAnimate} from "react-motion-animate";
import {FaUserAlt} from "react-icons/fa";
import SectionServices from "../components/sections/services";
import BooksSection from "../components/sections/products/book";
import QRCode from "react-qr-code";

import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

function AboutPage(props) {

    const { t, i18n } = useTranslation()

    const _contacts = [
        {
            title: "Phone",
            username: INFO.phoneLifecell,
            url: "tel.:" + INFO.phoneLifecell
        },
        {
            title: "E-Mail",
            username: INFO.email,
            url: "mailto:" + INFO.email
        },
        {
            title: "LinkedIn",
            username: 'a028481ab',
            url: INFO.socialLinkedIn
        },
        {
            title: "GitHub",
            username: "@yarikthe",
            url: INFO.socialGitHub
        }
    ]

    const _photos = [
        // "https://placehold.co/600x400",
        "/assets/photo/2.jpg",
        "/assets/photo/5.jpg",
        // "https://zt-rada.gov.ua/files/upload/sitephotos/img1593175223_6.jpg",
        "/assets/photo/11.jpg",
    ];

    const _photos2 = [
        // "https://placehold.co/600x400",
        "/assets/photo/7.jpeg",
        "/assets/photo/8.jpeg",
        "/assets/photo/10.jpg",
        "/assets/photo/9.jpg",
        // "https://zt-rada.gov.ua/files/upload/sitephotos/img1593175223_6.jpg",
    ];

    return (<div className={'min-vh-100 pb-5 p-md-0 p-3 pt-5'}>

        <Helmet>
            <title>{t('nav.about me')} - {t('my.name')}</title>
            <meta name="description" content="Yaroslav Lukyanchuk" />
        </Helmet>

        {/*<div id={'photos'} className="d-flex pt-5-mt-5">*/}
        {/*    {*/}
        {/*        _photos.map((photo, i) =>  <div key={i} className="photo col-md-12/5 about-img">*/}
        {/*            <Zoom> <img src={photo} alt={'photo_#' + i} className={'img-fluid'} /> </Zoom>*/}
        {/*        </div>)*/}
        {/*    }*/}

        {/*</div>*/}

        <div className={'container text-center pt-3'}>
            <small className={'text-secondary'}>
                About me
            </small>
        </div>

        <div className="photo-gallery">
            <div className="photo-card card-1">
                <img src="/assets/photo/2.jpg" alt="Фото 1" />
            </div>
            <div className="photo-card card-2">
                <img src="/assets/photo/5.jpg" alt="Фото 2" />
            </div>
            <div className="photo-card card-3">
                <img src="/assets/photo/11.jpg" alt="Фото 3" />
            </div>
            <div className="photo-card card-4">
                <img src="/assets/photo/yaroslav.png" alt="Фото 4" />
            </div>
        </div>


        <div className="container text-center">
            <h2 className={'opacity- m-auto'} style={{fontSize: '10vw'}}> {t('my.name')}</h2>
        </div>

        <div className="container d-flex flex-wrap d-none">
            <div>
                <h2>
                    About
                </h2>
            </div>
            <div>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem ea ex inventore mollitia quia, repudiandae sapiente! Autem, dicta ea, earum eveniet ex exercitationem fuga illum molestias quidem ratione, repudiandae totam!
                </p>
            </div>
            <div>
                <h2>
                    Work
                </h2>
            </div>
            <div>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolorem ea ex inventore mollitia quia, repudiandae sapiente! Autem, dicta ea, earum eveniet ex exercitationem fuga illum molestias quidem ratione, repudiandae totam!
                </p>
            </div>
        </div>

        <div className="container-fluid d-flex flex-wrap min-vh-1001 align-items-center justify-content-center" style={{marginTop: "30vh"}}>

            <div className="col-md-4 col-12 p-2 text-end">
                <img src="assets/photo/yaroslav2.png" alt="Yaroslav" className={'photo-card w-100 h-auto card-1'}/>
                <p className={'mt-5'}>
                    <a href="mailto:lukyanchuk@tuta.io" target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                        <>
                            lukyanchuk@tuta.io
                        </>
                    </a>
                </p>

                <p>
                    <a href="tel.:+380 (93) 075 13 57" target={'_blank'} className={'footer-link text-decoration-none text-secondary lead display-'}>
                        <>
                            +380 (93) 075 13 57
                        </>
                    </a>
                </p>
            </div>

            <div className="col-md-4 col-12 p-md-5 p-1 bg-white">
                <h2 className={'opacity-25 display-6'}>About Yaroslav</h2>
                <p>
                    Hello, I'm a perfectionist, minimalist, and programmer. I spend most of my days programming,
                    so I don't have much time to check my email. You can send me a message at the email address below if you want.
                    While I can't answer everyone, I read as many as I can. If you like my projects, videos,
                    you might like my news and posts where I delve even deeper into topics like self-development, creativity, and programming.
                    That's all. Thank you!
                </p>
                <h2 className={'opacity-25 display-6'}>About Lukyanchuk Books</h2>
                <p>
                    His remarkable career path led Pieter to return to Amsterdam in 2019 to establish Kleinmann Architecture. Much like Pieter, the studio considers itself very Dutch in its rigorous and clear approach to complicated design matters.
                    The attention to detail, material and texture raise the work beyond borders to an international level of understated sophistication.
                    We are a boutique size, internationally oriented firm predominantly focused on private residences, boutique retail & hospitality and high end offices.
                </p>
            </div>

            <div className="col-md-4 col-12 p-md-5 p-1">
                <h2 className={'opacity-25 display-6'}>My Mission</h2>
                <p>
                    Luxury for us is in a perfectly arranged and thoughtfully proportioned spatial sequence. A building which connects and deliberately disconnects. One that works for a single user, where one can focus in tranquility, yet also an environment where one can entertain at large. Our expertise is paired with that of skilled craftspeople and specialist construction teams to achieve a seemingly effortless level of service at all times.
                    Refinement for us is in timeless, authentic and tactile materials. Generous slabs of stone, solid pieces of timber and hand forged metals are combined with soft linens, suedes and cashmeres. Materials which can stand the test of time and which are gentle to the touch.
                    Sophistication for us is investing in everything you will never notice. A thoroughly engineered environment with seamlessly integrated services which offer minimal distraction from the interior atmosphere. Low-presence technology steers away from gimmicks and works for the building far in the background.
                    Architecture for us goes far beyond a building's exterior. We think about landscape, art, technology and service strategies. We are deeply passionate about integration of exterior and interior and both are equally important to us.
                </p>
            </div>

        </div>

        <div className="container vh-75 p-5 border rounded-5 mt-5">
            <BooksSection />
        </div>

        <div id={"name"} className="col-md-7 m-auto mt-5">

            <div className="text-center">
                <h4 className={'opacity-25 display-1'}>
                    {/*{t('nav.work')}*/}
                    About Lukyanchuk Apps / Software
                </h4>
            </div>

            <div className="mt-2">
                {/*<h4 className={'opacity-25 lead'}>{t('nav.work')}</h4>*/}
               <div className="d-flex justify-content-between align-items-start"  style={{height: '250px'}}>
                   <div className="col-md-8 p-1">

                       <p className="text-justify lead">
                           Розробкою програм та написанням сайтів я займаюся основну частину свого часу, оскільки це моя профільна робота за спеціальністю. В процесі розробки розробляється технічне завдання, яке буде слідувати за виконанням проектної роботи. Кожен проект має індивідуальний підхід, який проявляється в поглибленні предметної області, що дає найкращий результат процесу розробки та гарну програму в результаті.
                       </p>

                       <div className="d-flex flex-wrap justify-content-start align-items-start">

                           {
                               [
                                   {
                                       label: "nav.apps",
                                       url: "https://apps.y-l.pro"
                                   },
                                   {
                                       label: "nav.blog",
                                       url: "https://blog.y-l.pro"
                                   },
                                   {
                                       label: "nav.certificates",
                                       url: "certificates"
                                   },
                                   {
                                       label: "nav.science-work",
                                       url: "/work/science-work"
                                   },
                               ].map((item, i) => <div className="col-md-3">
                                   <div className="mt-3">
                                       <Link to={item.url} className={'p-1 nav-link'}>
                                           <b className={'border-bottom'}> {t(item.label)} </b>
                                           <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                                className="bi bi-arrow-up-right-square-fill m-1" viewBox="0 0 16 16">
                                               <path
                                                   d="M14 0a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zM5.904 10.803 10 6.707v2.768a.5.5 0 0 0 1 0V5.5a.5.5 0 0 0-.5-.5H6.525a.5.5 0 1 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 .707.707"/>
                                           </svg>
                                       </Link>
                                   </div>
                               </div>)
                           }

                       </div>

                   </div>

                   <div id={'resume'} className="col-md-3">

                       <div className="photo-card card-4"  style={{background: '#f7f7f7'}}>
                           <Link to={'https://cv.y-l.pro'} className={'nav-link  d-flex flex-column justify-content-center align-items-center p-5'} target={'_blank'}>
                               <FaUserAlt size={58} />
                               <b className={'display-6'}>
                                   {t('nav.resume')}
                               </b>
                               <small className="text-muted">
                                   add QR code
                               </small>
                           </Link>
                       </div>


                   </div>
               </div>

            </div>

            <div className="mt-5">
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquid amet architecto commodi consectetur eligendi eos est facere, fugiat impedit incidunt iure magni minus numquam perferendis quam quos, reiciendis rem!
                </p>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquid amet architecto commodi consectetur eligendi eos est facere, fugiat impedit incidunt iure magni minus numquam perferendis quam quos, reiciendis rem!
                </p>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad aliquid amet architecto commodi consectetur eligendi eos est facere, fugiat impedit incidunt iure magni minus numquam perferendis quam quos, reiciendis rem!
                </p>
            </div>

            {/*<div className="text-center">*/}
            {/*    <h4 className={'opacity-25 display-1'}>{t('nav.books')}</h4>*/}
            {/*</div>*/}
            <div className="vh-75 p-5 border rounded-5 mt-5">
                {/*TODO: replace on mobile app*/}
                <BooksSection />
            </div>

            {/*<p className="text-justify mt-5 lead- display-4 text-secondary">*/}
            {/*    <small>Більше фотографій можна переглянути у мене в instagram</small>*/}
            {/*    <Link to={'https://instagram.com/@yariklukyanchuk'} target={'_blank'}>*/}
            {/*        <b className={'text-dark'}>@yariklukyanchuk</b>*/}
            {/*    </Link>*/}
            {/*</p>*/}
        </div>

        {/*<div id={'media'} className="d-flex pt-5 mt-5">*/}
        {/*    {*/}
        {/*        _photos2.map((photo, i) =>  <div key={i} className="photo col-md-3 text-center about-img">*/}

        {/*            <Zoom> <img src={photo} alt={'photo_#' + i} className={'img-fluid'} /> </Zoom>*/}
        {/*        </div>)*/}
        {/*    }*/}
        {/*</div>*/}

        <div id={"contacts"} className="col-md-10 m-auto text-start mt-5 pt-3 d-flex flex-wrap">

            <div className="col-md-3 col-12">
                <h2 className={'display-3'}>Connect</h2>
                <p className="text-justify text-muted lead">
                    Scan QR code for get contact.
                </p>
            </div>
            <div className="col-md-9 col-12">
                <div className="d-flex justify-content-between flex-wrap mt-5 mb-5">
                    {
                        _contacts.map((contact, i) => <div className="col-md-auto col-6">
                            <div className={"text-center w-100 photo-card card-" + (i+1)}>
                                <Zoom>
                                    <QRCode
                                        size={256}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={contact.url}
                                        viewBox={`0 0 256 256`}
                                    />
                                </Zoom>
                                {/*<small>{contact.username}</small>*/}
                                <small>{contact.title}</small>
                                {/*<p className={'display-6'}>*/}
                                {/*    <Link to={contact.url} className={'nav-link'} target={'_blank'}>{contact.title}</Link>*/}
                                {/*</p>*/}
                            </div>
                        </div>)
                    }
                </div>
            </div>
        </div>

        {/*DEV SECTION*/}
        <div className="tree-line d-none">
            date - version website
            <VerticalTimeline>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                    date="2011 - present"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={'<WorkIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Creative Director</h3>
                    <h4 className="vertical-timeline-element-subtitle">Miami, FL</h4>
                    <p>
                        Creative Direction, User Experience, Visual Design, Project Management, Team Leading
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2010 - 2011"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={'<WorkIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Art Director</h3>
                    <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
                    <p>
                        Creative Direction, User Experience, Visual Design, SEO, Online Marketing
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2008 - 2010"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={'<WorkIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Web Designer</h3>
                    <h4 className="vertical-timeline-element-subtitle">Los Angeles, CA</h4>
                    <p>
                        User Experience, Visual Design
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--work"
                    date="2006 - 2008"
                    iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                    icon={'<WorkIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Web Designer</h3>
                    <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
                    <p>
                        User Experience, Visual Design
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="April 2013"
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    icon={'<SchoolIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Content Marketing for Web, Mobile and Social Media</h3>
                    <h4 className="vertical-timeline-element-subtitle">Online Course</h4>
                    <p>
                        Strategy, Social Media
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="November 2012"
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    icon={'<SchoolIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Agile Development Scrum Master</h3>
                    <h4 className="vertical-timeline-element-subtitle">Certification</h4>
                    <p>
                        Creative Direction, User Experience, Visual Design
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    className="vertical-timeline-element--education"
                    date="2002 - 2006"
                    iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                    icon={'<SchoolIcon />'}
                >
                    <h3 className="vertical-timeline-element-title">Bachelor of Science in Interactive Digital Media Visual Imaging</h3>
                    <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
                    <p>
                        Creative Direction, Visual Design
                    </p>
                </VerticalTimelineElement>
                <VerticalTimelineElement
                    iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                    icon={'<StarIcon />'}
                />
            </VerticalTimeline>
        </div>

    </div>);
}

export default AboutPage;
